import { FC, useState } from 'react';

import PageTitle from '../shared/PageTitle';
import DashboardLayout from '../layouts/dashboard';
import Overview from '../modules/dashboard/Overview';
import { CredusText, CredusWrapper } from 'ui';
import AnalyticsData from '../modules/dashboard/AnalyticsData';
import EmptyState from '../shared/EmptyState';
import { BreadCrumb } from './TestManagement';
import { useQuery } from 'react-query';
import reportApi from '../api/report';
import ComponentLoader from '../modules/test-management/ComponentLoader';
import { Link } from 'react-router-dom';

const Dashboard: FC = () => {
  const [institutionId] = useState(localStorage.getItem('c-iid') || '');
  const [dashboardSortOrder, setDashboardSortOrder] = useState<
    'Month' | 'Week'
  >('Week');
  /**get overView api call */
  const { data, isLoading } = useQuery(
    ['getOverview', institutionId, dashboardSortOrder],
    () =>
      reportApi.getOverview({
        institutionId: Number(institutionId),
        dashboardSortOrder,
      })
  );

  const { data: getTestTakerCountData } =
    useQuery(['getTestTakerCount', institutionId], () =>
      reportApi.getTestTakerCount(+institutionId)
    );

  const { data: getUpcomingTestData } =
    useQuery(['getUpcomingTests', institutionId], () =>
      reportApi.getUpcomingTests(+institutionId)
    );

  const { data: getTestIntegrity } =
    useQuery(['getTestIntegrity', institutionId], () =>
      reportApi.getTestIntegrity(+institutionId)
    );

  const {
    data: getTotalTestSuccessRate,
  } = useQuery(['getTotalTestSuccessRate', institutionId], () =>
    reportApi.getTotalTestSuccessRate(+institutionId)
  );

  return (
    <DashboardLayout
      name="Dashboard"
      breadCrumbs={
        <BreadCrumb>
          <Link to="/dashboard" className="breadcrumb-link">
            <CredusText color={'#7a7a7a'} size="sm">
              Dashboard
            </CredusText>
          </Link>
        </BreadCrumb>
      }
    >
      <PageTitle name="Overview" color="#2B2D42" />
      <Overview
        data={{
          ...data,
          registeredTestTakers: getTestTakerCountData?.value,
          upcomingTest: getUpcomingTestData?.value,
          testIntegrity: getTestIntegrity?.value,
          testSuccessRate: getTotalTestSuccessRate?.value,
        }}
      />
      <CredusWrapper mt="1.8rem">
        <PageTitle name="Analytics Data" color="#2B2D42" />
      </CredusWrapper>
      <CredusWrapper padding="1.2rem 1.1rem 1.2rem 1.4rem" pr="" bg="#fff">
        {isLoading ? (
          <ComponentLoader loaderText="Loading..." />
        ) : (
          <>
            {data?.tests?.length === 0 ? (
              <EmptyState description="No available data " margin="8rem 0rem" />
            ) : (
              <AnalyticsData data={data} setSort={setDashboardSortOrder} />
            )}
          </>
        )}
      </CredusWrapper>
    </DashboardLayout>
  );
};

export default Dashboard;
